<template>
<div>
    <b-navbar variant="info" type="light" style="margin-bottom:25px;">
    <b-navbar-brand href="#" style="color:white;">
      <img src="https://placekitten.com/g/30/30" class="d-inline-block align-top" alt="Kitten">
      Dolphin - DOmain Logo Protein for Human INformation
    </b-navbar-brand>
  </b-navbar>
  </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Navbar component mounted.')
        }
    }
</script>
